import WaterDropOutlinedIcon from '@mui/icons-material/WaterDropOutlined';

/**
 * Cor da urina: escala de 8 tons de Armstrong (Armstrong et al., Int J Sport
 * Nutr, 1994; validada de novo em 1998), do 1 (amarelo-palha bem claro) ao 8
 * (âmbar acastanhado escuro). Faixas: 1 a 3 hidratado, 4 e 5 atenção, 6 a 8
 * desidratado. Textos nossos; as cores são só uma amostra visual.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/urine_color.php.
 */
const urineColor = {
  key: 'urine_color',
  name: 'Cor da urina',
  description: 'Estado de hidratação pela cor da urina, do 1 ao 8',
  details: 'Compara a cor da urina com oito tons, do 1 (amarelo bem claro) ao 8 (âmbar escuro), como na escala de Armstrong. Quanto mais escura, mais concentrada e menor a hidratação: 1 a 3 indicam boa hidratação, 4 e 5 pedem atenção e 6 a 8 sugerem desidratação. Vale olhar a amostra num copo transparente, não no vaso. Vitaminas, alguns remédios e alimentos podem mudar a cor. Um clique marca o tom do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: WaterDropOutlinedIcon,
  accent: 'amber',
  options: [
    { value: '1', label: '1', color: '#FBF7D8', group: 'Hidratado', help: 'Quase transparente, amarelo-palha muito claro. Boa hidratação.' },
    { value: '2', label: '2', color: '#F8EFAE', group: 'Hidratado', help: 'Amarelo-palha claro. Boa hidratação.' },
    { value: '3', label: '3', color: '#F4E37E', group: 'Hidratado', help: 'Amarelo claro. Ainda dentro da faixa hidratada.' },
    { value: '4', label: '4', color: '#EDCF52', group: 'Atenção', help: 'Amarelo mais forte. Hidratação no limite, vale beber água.' },
    { value: '5', label: '5', color: '#E1B635', group: 'Atenção', help: 'Amarelo escuro. Começo de desidratação, aumentar a ingestão de líquidos.' },
    { value: '6', label: '6', color: '#CD9A27', group: 'Desidratado', help: 'Âmbar. Desidratação, repor líquidos.' },
    { value: '7', label: '7', color: '#AD7A1E', group: 'Desidratado', help: 'Âmbar escuro. Desidratação importante.' },
    { value: '8', label: '8', color: '#7F5A1C', group: 'Desidratado', help: 'Âmbar acastanhado. Desidratação intensa; se persistir com boa ingestão, investigar outras causas.' },
  ],
};

export default urineColor;
